<ng-template ngFor let-pedigree [ngForOf]="pedigreeGroup">
  <td class="centered" id="pedigree-group" style="height: 130px">
    <div #gpfPedigreeHost></div>
  </td>
</ng-template>
